import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import MUITooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { arrow, popper, tooltip } from './Tooltip.style';

const styles = () => ({
  arrow,
  popper,
  tooltip,
});

const Tooltip = ({ title, position, children, classes, ...props }) => {
  const [arrowRef, setArrowRef] = React.useState(null);
  const handleArrowRef = useCallback((node) => {
    if (node !== null) {
      setArrowRef(node);
    }
  }, []);

  if (!title) {
    return children;
  }

  return (
    <MUITooltip
      title={
        <>
          {title}
          <span className={classes.arrow} ref={handleArrowRef} />
        </>
      }
      classes={{
        tooltip: classes.tooltip,
        popper: classes.popper,
      }}
      PopperProps={{
        style: {
          position: 'absolute',
          inset: '0 auto auto 0',
        },
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(arrowRef),
              element: arrowRef,
            },
          },
        },
      }}
      placement={position}
      {...props}
    >
      {children}
    </MUITooltip>
  );
};

Tooltip.defaultProps = {
  position: 'top',
};

Tooltip.propTypes = {
  /** The content of the tooltip description */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  children: PropTypes.node.isRequired,

  /** Position of the tooltip in relation to the wrapped element */
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** Classes for specifying custom styling for 'arrow', 'popper' and 'tooltip */
  classes: PropTypes.shape({
    arrow: PropTypes.string.isRequired,
    popper: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
  }).isRequired,
};

export default React.memo(withStyles(styles)(Tooltip));
